﻿

(() => {
    angular.module('fliptoWeb')
        .controller('GetStartedCtrl', ['$window',
        function ($window) {
            "use strict";

            var vm = this;

            var trackingInfo = {
                modalAbandon: {
                    submitted: "closed modal after demo request form submit",
                    abandon: "hard abandoned demo request"
                }
            }

            vm.isIntro = () => {
                return $window.isIntro;
            }

            vm.isPartner = () => {
                return $window.isPartner;
            }

            //handles hide/show of sections
            //required for directive get-started
            vm.activeSection = $window.isIntro || $window.isPartner ? 4 : 0;

            vm.hasBeenSubmitted = false;

            //handles switching sections
            //required for directive get-started
            vm.activateSection = (section) => {
                //updateSection method is defined inside the directive.
                vm.dirGetStartedAccessor.updateSection(section);
                vm.activeSection = section;
            }

            vm.setSubmittedState = (val) => {
                vm.dirGetStartedAccessor.updateSection(val);
                vm.hasBeenSubmitted = val;
            }

            vm.trackingInfo = () => {
                return vm.hasBeenSubmitted ? trackingInfo.modalAbandon.submitted : trackingInfo.modalAbandon.abandon;
            }

            /**
             * Go back to router view
             * @returns {} 
             */
            vm.goBack = () => {
                vm.activateSection(0);
            };

            //model property accessor for directive/controller communications
            //required for directive get-started
            vm.dirGetStartedAccessor = {
                activateSection: vm.activateSection,
                activeSection: vm.activeSection,
                hasBeenSubmitted: vm.hasBeenSubmitted,
                setSubmittedState: vm.setSubmittedState
            };
        }]);
})()
